import InfoIcon from '@mui/icons-material/InfoOutlined';
import { Trans } from 'react-i18next';

import { Skeleton } from 'shared/components/Skeleton';
import { Action as SharedAction } from 'shared/components/Tile';
import { Tooltip } from 'shared/components/Tooltip';

import type { CumulativeGradesProps } from 'applications/GSP/entities/CumulativeGrades/types';
import type { InspiredGlobalStudyPlatformApiModelsChartGradeType as GradeType } from 'applications/GSP/shared/api/gsp';
import type { FC } from 'react';

interface ActionProps extends Pick<CumulativeGradesProps, 'isLoading'> {
  gradeType: GradeType;
}

export const Action: FC<ActionProps> = ({ isLoading, gradeType }) => {
  if (isLoading) {
    return (
      <SharedAction>
        <Skeleton width={24} height={24} />
      </SharedAction>
    );
  }

  return (
    <SharedAction>
      <Tooltip
        title={
          <Trans
            i18nKey={`GSP.entities.cumulativeGrades.infos.${gradeType.toLowerCase()}`}
          />
        }
      >
        <InfoIcon color="action" />
      </Tooltip>
    </SharedAction>
  );
};
